import { useYardStores } from '@yard/AppProvider'
import { useTranslate } from '@tolgee/react'
import { ConfirmationDialog } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import DGStackingRulesTableForm from '../forms/dg-stacking-rules-table-form/DGStackingRulesTableForm'
import { DGStackingRuleFormProfile } from '../forms/dg-stacking-rules-table-form/dg-stacking-rules-table-form.profile'

const DGStackingRulesTableDialog = observer(() => {
  const { t } = useTranslate()
  const { dgStackingRulesTableUIStore } = useYardStores()

  const formId = 'dg-stacking-rules-table-form'

  const handleOnClose = () => dgStackingRulesTableUIStore.closeDialog()

  const handleOnSubmit = async (formValues: DGStackingRuleFormProfile) =>
    await dgStackingRulesTableUIStore.update(formValues, handleOnClose)

  return (
    <>
      <ConfirmationDialog
        open={dgStackingRulesTableUIStore.isDialogOpen}
        title={t('editDGStackingRule', 'Edit DG Stacking Rule')}
        primaryActionText={t('save', 'Save')}
        closeLabel={t('cancel', 'Cancel')}
        formId={formId}
        maxWidth='xs'
        onClose={handleOnClose}
        hasBorderTop
      >
        {dgStackingRulesTableUIStore.isDialogOpen && dgStackingRulesTableUIStore.dialogEntity && (
          <DGStackingRulesTableForm
            id={formId}
            onSubmit={handleOnSubmit}
            dgStackingRuleDto={dgStackingRulesTableUIStore.dialogEntity}
          />
        )}
      </ConfirmationDialog>
      <ConfirmationDialog
        open={dgStackingRulesTableUIStore.isResetDialogOpen}
        title={t('resetDGStackingRulesToDefaults', 'Reset DG Stacking Rules to Defaults')}
        primaryActionText={t('resetToDefaults', 'Reset to defaults')}
        closeLabel={t('cancel', 'Cancel')}
        maxWidth='xs'
        message={t(
          'resetDGStackingRulesToDefaultsConfirmation',
          'This will overwrite all current DG stacking rules for this tenant with the default IMDG stacking rules.',
        )}
        onClose={() => dgStackingRulesTableUIStore.toggleResetDialog()}
        onConfirm={() => dgStackingRulesTableUIStore.resetToDefaults()}
        blockClickOutside
      />
    </>
  )
})

export default DGStackingRulesTableDialog
